import { Delete } from '@mui/icons-material';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Button, IconButton, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrganizationRoleButton } from './organizationRoleButton';
import { EmptyGridCell } from '../atoms/emptyGridCell';

type OrganizationRoleTableProps<T> = {
  roles: Array<T>;
  idColumn: string;
  titleColumn: string;
  resDateColumn: string;
  valueColumn: string;
  setUserCallback: (id: any) => void;
  editDateCallback: (id: any) => void;
  deleteCallback: (id: any) => void;
};

export const OrganizationRoleTable = <T,>(props: OrganizationRoleTableProps<T>) => {
  const { roles, idColumn, titleColumn, resDateColumn, valueColumn, setUserCallback, editDateCallback, deleteCallback } = props;
  const { t } = useTranslation(['common']);
  return (
    <TableContainer>
      <Table aria-label='simple table' size='medium'>
        <TableHead>
          <TableRow sx={{ color: (thm) => thm.palette.text.secondary, fontWeight: 500 }}>
            <TableCell>{t('common:organization.tableHeader.title')}</TableCell>
            <TableCell>{t('common:organization.tableHeader.name')}</TableCell>
            <TableCell>{t('common:organization.tableHeader.date')}</TableCell>
            <TableCell>{t('common:organization.tableHeader.edit')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {roles.map((row) => {
            const isDisabled = !row[valueColumn];
            return (
              <TableRow key={row[idColumn]} hover>
                <TableCell component={'th' as any} scope='row'>
                  <Typography variant='body1' sx={{ fontWeight: 600 }}>
                    {row[titleColumn]}
                  </Typography>
                </TableCell>
                <TableCell>
                  <OrganizationRoleButton
                    buttonValue={row[valueColumn]}
                    vacantLabel={t('common:organization.vacantLabel')}
                    editDateAction={() => editDateCallback(row[idColumn])}
                    setUserAction={() => setUserCallback(row[idColumn])}
                  />
                </TableCell>
                <TableCell>{row[resDateColumn] || <EmptyGridCell />}</TableCell>
                <TableCell width='10%'>
                  {isDisabled && <EmptyGridCell />}
                  {!isDisabled && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Button variant='text' size='small' onClick={() => editDateCallback(row[idColumn])}>
                        {t('common:button.change')}
                      </Button>
                      <IconButton size='small' onClick={() => deleteCallback(row[idColumn])}>
                        <Delete sx={{ color: (thm) => thm.palette.action.active }} />
                      </IconButton>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
